import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';

@Component({
  selector: 'app-navigation-modal',
  templateUrl: './navigation-modal.component.html',
  styleUrls: ['./navigation-modal.component.css']
})
export class NavigationModalComponent implements OnInit {

  constructor(private rootScopeService:RootScopeService) { }
  cloudBasePath: string;
  rootScopeData:RootScopeDeclare;

  @Output() onClose:EventEmitter<string>=new EventEmitter();
  ngOnInit() {
    this.cloudBasePath=environment.cloudBasePath;
    this.getRootScopeData();
  }

  closeNavigationModal(){
    this.onClose.emit();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData =>
      { this.rootScopeData = rootScopeData;

    });
  }
}
